import { observer } from "mobx-react";
import * as React from "react";
import { Link } from "react-router";
import styled from "styled-components";

import DropdownAction, {
  Action as DropdownActionType,
} from "@client/components/ui/DropdownAction";
import Style from "@client/utils/Style";

import backImage from "./images/back.svg";

const Wrapper = styled.div`
  height: 96px;
  background: ${Style.palette.grayscale[1]};
  display: flex;
  justify-content: center;
`;
const Content = styled.div`
  display: flex;
  align-items: center;
`;
const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 64px;
`;
const BackButton = styled(Link)`
  width: 32px;
  height: 32px;
  background: url("${backImage}") center no-repeat;
`;
const Icon = styled.div<{ image: string }>`
  width: 64px;
  height: 64px;
  background: url("${(props: any) => props.image}") center no-repeat;
  margin-left: 14px;
`;
const MiddleWrapper = styled.div`
  width: 928px;
  display: flex;
  align-items: center;
`;
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const Title = styled.div`
  font-size: 30px;
  font-weight: ${Style.fontWeights.light};
`;
const Subtitle = styled.div`
  color: ${Style.palette.grayscale[4]};
`;

type Props = {
  icon: any;
  title: string;
  subtitle: React.ReactNode;
  backLink: string;
  dropdownActions: DropdownActionType[];
};

@observer
class DetailsPageActionBar extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        <Content>
          <LeftWrapper>
            <BackButton to={this.props.backLink} />
            <Icon image={this.props.icon} />
          </LeftWrapper>
          <MiddleWrapper>
            <TitleWrapper>
              <Title>{this.props.title}</Title>
              <Subtitle>{this.props.subtitle}</Subtitle>
            </TitleWrapper>
            {this.props.dropdownActions.length ? (
              <DropdownAction actions={this.props.dropdownActions} />
            ) : null}
          </MiddleWrapper>
        </Content>
      </Wrapper>
    );
  }
}

export default DetailsPageActionBar;
